import React, { Component } from "react";
import { Fade } from "react-reveal";
import {
  greeting,
  projectsHeader,
  churchFeaturesData,
} from "../../portfolio.js";
import Button from "../../components/button/Button";
import Church3DViewer from "../../components/churchViewer/Church3DViewer";
import "./ProjectsSection.css";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";

const ProjectsContent = ({ theme }) => {
  const { language } = useLanguage();

  // Map feature names to translation keys
  const featureKeyMap = {
    "Holy Qurbana (Divine Liturgy)": "holy_qurbana",
    "Sacraments of the Church": "sacraments",
    "Spiritual Direction & Confession": "spiritual_direction",
    "Fasting & Prayer Disciplines": "fasting_prayer",
    "Ge'ez Language & Liturgy": "geez_language",
    "Community & Cultural Heritage": "community",
  };

  return (
    <div className="projects-main">
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="projects-heading-div">
            <div className="projects-heading-img-div">
              <Church3DViewer
                imagePath={require("../../assets/images/churchdesign.png")}
              />
            </div>
            <div className="projects-heading-text-div">
              <h1
                className="projects-heading-text"
                style={{ color: theme.text }}
              >
                {getTranslation(language, "church_building_project")}
              </h1>
              <p
                className="projects-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {getTranslation(language, "church_building_desc")}
              </p>
            </div>
          </div>
        </Fade>
      </div>

      <div className="repo-cards-div-main">
        {churchFeaturesData.features.map((feature) => {
          // Get the translation key from the map, fallback to the feature name
          const featureKey =
            featureKeyMap[feature.name] ||
            feature.name.toLowerCase().replace(/\s+/g, "_");
          const descKey = featureKey + "_desc";

          return (
            <Fade key={feature.id} bottom duration={1500} distance="40px">
              <div
                className="card repo-card"
                style={{ borderColor: theme.highlight }}
              >
                <div className="card-body">
                  <div
                    className="feature-icon"
                    style={{ fontSize: "48px", marginBottom: "15px" }}
                  >
                    <i
                      className={`fas ${feature.icon}`}
                      style={{ color: theme.highlight }}
                    ></i>
                  </div>
                  <h5 className="card-title" style={{ color: theme.text }}>
                    {getTranslation(language, featureKey) || feature.name}
                  </h5>
                  <p
                    className="card-subtitle small"
                    style={{ color: theme.secondaryText }}
                  >
                    {getTranslation(language, descKey) || feature.description}
                  </p>
                </div>
              </div>
            </Fade>
          );
        })}
      </div>

      <Button
        text={getTranslation(language, "help_build_church")}
        className="project-button"
        href={greeting.portfolio_repository}
        newTab={true}
        theme={theme}
      />
    </div>
  );
};

class ProjectsSection extends Component {
  render() {
    const theme = this.props.theme;
    return <ProjectsContent theme={theme} />;
  }
}

export default ProjectsSection;
